import React, { useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { TartaEmblem } from './TartaEmblem';
export function Waitlist() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: ''
  });
  const [errors, setErrors] = useState<{
    name?: string;
    email?: string;
  }>({});
  const [submitted, setSubmitted] = useState(false);
  const validate = () => {
    const e: typeof errors = {};
    if (!form.name.trim()) e.name = 'Required';
    if (!form.email.trim()) e.email = 'Required';else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = 'Invalid email';
    setErrors(e);
    return Object.keys(e).length === 0;
  };
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitted(true);
  };
  return <section id="waitlist" className="bg-texture-dark text-cream py-32 lg:py-48 relative overflow-hidden" data-id="element-281">
      <div className="max-w-[820px] mx-auto px-8 lg:px-14" data-id="element-282">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-283">
          <div className="absolute -inset-1 border border-cream/15 pointer-events-none" aria-hidden data-id="element-284" />
          <div className="border border-cream/25 px-8 py-16 sm:px-16 sm:py-20 lg:px-24 lg:py-24 text-center bg-chocolate/40 backdrop-blur-sm" data-id="element-285">
            <div className="flex flex-col items-center gap-8 mb-12" data-id="element-286">
              <TartaEmblem size={104} variant="dark" withTagline className="ring-1 ring-cream/20" data-id="element-287" />
              <span className="font-serif italic text-caramel text-[13px] tracking-[0.05em]" data-id="element-288">
                — by invitation —
              </span>
            </div>

            <h2 className="font-serif text-cream font-light leading-[0.95] tracking-[-0.025em]" style={{
            fontSize: 'clamp(44px, 7vw, 96px)'
          }} data-id="element-289">
              The First
              <br data-id="element-290" />
              <span className="italic font-extralight" data-id="element-291">Bite List</span>
            </h2>

            <p className="mt-10 text-cream/55 leading-[1.85] text-[15px] max-w-md mx-auto" data-id="element-292">
              Our debut release is intentionally small. Members receive a
              private notice before doors open to the public — and first access
              when pre-orders begin.
            </p>

            <ul className="mt-12 flex flex-col sm:flex-row sm:flex-wrap items-center justify-center gap-y-4 sm:gap-x-6 lg:gap-x-10 text-[10px] tracking-[0.3em] uppercase text-cream/55" data-id="element-293">
              {[{
              n: 'i.',
              label: 'Private launch notice'
            }, {
              n: 'ii.',
              label: 'First access to pre-orders'
            }, {
              n: 'iii.',
              label: 'Limited first edition'
            }].map((item, idx) => <Fragment key={item.n} data-id="element-294">
                  <li className="flex items-baseline gap-3 whitespace-nowrap" data-id="element-295">
                    <span className="font-serif italic text-caramel normal-case tracking-[0.05em] text-[13px]" data-id="element-296">
                      {item.n}
                    </span>
                    <span data-id="element-297">{item.label}</span>
                  </li>
                  {idx < 2 && <span className="hidden sm:inline w-1 h-1 rounded-full bg-caramel/50" aria-hidden data-id="element-298" />}
                </Fragment>)}
            </ul>

            {!submitted ? <form onSubmit={onSubmit} noValidate className="mt-16 max-w-md mx-auto text-left space-y-8" data-id="element-299">
                <Field label="Name" value={form.name} onChange={v => setForm({
              ...form,
              name: v
            })} error={errors.name} placeholder="Full name" data-id="element-300" />
                <Field label="Email" type="email" value={form.email} onChange={v => setForm({
              ...form,
              email: v
            })} error={errors.email} placeholder="you@example.com" data-id="element-301" />
                <Field label="Phone" optional type="tel" value={form.phone} onChange={v => setForm({
              ...form,
              phone: v
            })} placeholder="(optional)" data-id="element-302" />

                <div className="pt-8 text-center" data-id="element-303">
                  <button type="submit" className="group inline-flex items-center gap-5 text-cream" data-id="element-304">
                    <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-305" />
                    <span className="font-serif italic text-[15px] tracking-[0.05em]" data-id="element-306">
                      Request an invitation
                    </span>
                    <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-307" />
                  </button>
                  <p className="mt-8 text-[10px] tracking-[0.3em] uppercase text-cream/35" data-id="element-308">
                    No spam — only sweet, deliberate updates.
                  </p>
                </div>
              </form> : <motion.div initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} className="mt-16" data-id="element-309">
                <p className="text-[10px] tracking-[0.5em] uppercase text-caramel mb-8" data-id="element-310">
                  — Confirmed —
                </p>
                <h3 className="font-serif text-4xl sm:text-5xl leading-[1.05] font-light" data-id="element-311">
                  Welcome,
                  <br data-id="element-312" />
                  <span className="italic font-extralight" data-id="element-313">
                    {form.name.split(' ')[0]}.
                  </span>
                </h3>
                <p className="mt-8 text-cream/60 leading-[1.85] text-[15px] max-w-md mx-auto" data-id="element-314">
                  Your place is reserved on the First Bite List. We'll be in
                  touch when something special is ready.
                </p>
              </motion.div>}
          </div>
        </motion.div>
      </div>
    </section>;
}
function Field({
  label,
  value,
  onChange,
  error,
  type = 'text',
  placeholder,
  optional
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  error?: string;
  type?: string;
  placeholder?: string;
  optional?: boolean;
}) {
  return <div data-id="element-315">
      <div className="flex items-baseline justify-between mb-3" data-id="element-316">
        <label className="text-[10px] tracking-[0.3em] uppercase text-cream/50" data-id="element-317">
          {label}
        </label>
        {optional && <span className="text-[10px] tracking-[0.2em] uppercase text-cream/25" data-id="element-318">
            Optional
          </span>}
      </div>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="w-full bg-transparent border-b border-cream/20 focus:border-caramel outline-none py-3 text-cream placeholder:text-cream/25 transition-colors duration-500 font-serif text-lg" data-id="element-319" />
      {error && <p className="text-caramel/80 text-[10px] tracking-[0.2em] uppercase mt-3" data-id="element-320">
          {error}
        </p>}
    </div>;
}